import { render, staticRenderFns } from "./MediaReportDetailChart.vue?vue&type=template&id=977f84d6&"
import script from "./MediaReportDetailChart.vue?vue&type=script&lang=js&"
export * from "./MediaReportDetailChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports